import { FiShield } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const Forbidden = () => {
  return (
    <div className="h-full min-h-0 flex items-center justify-center">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-lg p-6 text-center">
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-rose-100 text-rose-700 mb-4">
          <FiShield className="text-xl" />
        </div>
        <h2 className="text-lg font-semibold text-slate-900">403 - Không có quyền truy cập</h2>
        <p className="text-sm text-slate-600 mt-2">
          Bạn không có quyền truy cập màn hình này theo phân quyền user_menu.
        </p>
        <div className="mt-5">
          <Link to="/dashboard" className="inline-flex items-center px-3 py-2 rounded bg-primary text-white text-sm">
            Về trang tổng quan
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Forbidden;
